import React from 'react';
import PropTypes from 'prop-types';
import {
  Autocomplete,
  Box,
  CircularProgress,
  TextField,
  Typography,
} from '@mui/material';
import { SelectedEntityCard } from '../../../../../components/guardian/PrincipalFormComponents';
import {
  buildPgCardRows,
  getPgNotInListLinkClass,
} from './pgSectionConfig';

export default function ProfessionalGuardianLookupSection({
  index,
  guardian,
  guardians,
  config,
  professionalGuardians,
  loadingGuardians = false,
  isDisabled = false,
  updateGuardianAt,
  fetchProfessionalGuardianDetails,
}) {
  const selectedPg = professionalGuardians.find(
    (pg) => pg.value === guardian.professional_guardian
  );

  return (
    <Box {...(config.boxSx != null ? { sx: config.boxSx } : {})}>
      <Autocomplete
        options={professionalGuardians}
        value={selectedPg || null}
        disabled={isDisabled}
        getOptionLabel={(option) => option.label || ''}
        loading={loadingGuardians}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Search Professional Guardian"
            variant="outlined"
            fullWidth
            slotProps={{
              input: {
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loadingGuardians ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              },
            }}
          />
        )}
        onChange={(event, newValue) => {
          if (newValue) {
            updateGuardianAt(
              index,
              {
                professional_guardian: newValue.value,
                is_new_pg: false,
              },
              guardians
            );
            fetchProfessionalGuardianDetails(index, newValue.value);
          }
        }}
      />
      <SelectedEntityCard
        title="Selected Professional Guardian:"
        rows={buildPgCardRows(selectedPg, config)}
      />
      <Typography
        variant="body2"
        className={`mt-2 ${getPgNotInListLinkClass(isDisabled)}`}
        onClick={() => {
          if (isDisabled) return;
          updateGuardianAt(index, { showFullForm: true, is_new_pg: true }, guardians);
        }}
        sx={{ mt: 2 }}
      >
        Professional Guardian not in the list?
      </Typography>
    </Box>
  );
}

ProfessionalGuardianLookupSection.propTypes = {
  index: PropTypes.number.isRequired,
  guardian: PropTypes.object.isRequired,
  guardians: PropTypes.array.isRequired,
  config: PropTypes.shape({
    boxSx: PropTypes.object,
    rowKeys: PropTypes.arrayOf(PropTypes.string),
    addressOptionKey: PropTypes.string,
  }).isRequired,
  professionalGuardians: PropTypes.array.isRequired,
  loadingGuardians: PropTypes.bool,
  isDisabled: PropTypes.bool,
  updateGuardianAt: PropTypes.func.isRequired,
  fetchProfessionalGuardianDetails: PropTypes.func.isRequired,
};

ProfessionalGuardianLookupSection.defaultProps = {
  loadingGuardians: false,
  isDisabled: false,
};
